export default __webpack_public_path__ + "static/media/tin-can-phone.d75e3ae2.png";